// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FileWordTwoToneSvg from "@ant-design/icons-svg/es/asn/FileWordTwoTone";
import AntdIcon from '../components/AntdIcon';

var FileWordTwoTone = function FileWordTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: FileWordTwoToneSvg
  }));
};

FileWordTwoTone.displayName = 'FileWordTwoTone';
export default React.forwardRef(FileWordTwoTone);